import cmsAPI from '@/services/API/cmsAPI'


const fetchCMSProducts = function({ commit, state }) {
  if(state.outDated){

    if (state.search != null && state.search !== '') {
      commit('SET_CURRENT_PAGE', 1);
    }

    const params = {
      t: state.search,
      page: state.currentPage,
    }
    commit('SET_LOADING', true);
    return cmsAPI.fetchCMSProducts(params)
      .then(products=>{
        commit('SET_PRODUCTS', products.results);
        commit('SET_TOTAL_PRODUCTS', products.total);
        commit('SET_TOTAL_PAGES', Math.ceil(products.total / 50));
        commit('SET_LOADING', false);
      })
  }
};
let searchTimeOut = null;
const setSearch = function({ commit, state, dispatch }, search) {
  commit('SET_SEARCH',search);

  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut);
  searchTimeOut = setTimeout(() => {
    commit('INVALIDATE');
    dispatch('fetchCMSProducts')
  }, 300)

};

const invalidate = function({commit}) {
  commit('INVALIDATE')
}

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.currentPage < state.totalPages) {
    commit('SET_CURRENT_PAGE', state.currentPage + 1);
    dispatch('invalidate');
    dispatch('fetchCMSProducts');
  }
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.currentPage > 1) {
    commit('SET_CURRENT_PAGE', state.currentPage - 1);
    dispatch('invalidate');
    dispatch('fetchCMSProducts');
  }
}

const updateProduct = function({commit, state}, product) {
  commit('UPDATE_PRODUCT', product);
}

const setPublishProduct = function({commit, state}, {id, publishInd}) {
  commit('SET_PUBLISH_IND', {id, publishInd});
}



export default {
  fetchCMSProducts,
  setSearch,
  invalidate,
  fetchNextPage,
  fetchPreviousPage,
  updateProduct,
  setPublishProduct,
};
